module.exports = __webpack_public_path__ + "img/freezingrain.e5d3df47.png";